import React from 'react';

import { Badge, ChangeDot, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

export const TopImpactStoryBadge: React.FC<{
	labelTitle: string;
	labelText: string;
	dataTestId: string;
	isCenteredOnMobile: boolean;
	isMobile: boolean;
}> = ({ labelTitle, labelText, dataTestId, isCenteredOnMobile, isMobile }) => {
	return (
		<div className="absolute z-30 w-full -translate-y-1/2">
			<Badge
				data-testid={dataTestId}
				aria-hidden
				className={cn(
					[
						'relative transform cursor-pointer justify-center border px-6 py-2',
						// Not using sunrise color here as that is transparent and requires it to be
						// applied on a white background with a pseudo element
						'bg-[#FAF8FD]',
						'border-stroke-weaker text-typography-strong',
						'group-focus-within:text-typography-inverse-strong group-hover:text-typography-inverse-strong',
						'group-hover:transition-all group-hover:duration-300',
						// Create pseudo element for the hover state bg
						'before:absolute before:-inset-[1px] before:rounded-full before:content-[""]',
						'before:bg-gradient-background-dark-2',
						// Not using sunrise colors here because designs are using a gradient border
						// which is not supported by the tokens yet
						'before:border-[2px] before:border-[#0D4DFB]',
						// Animate opacity on group-hover
						'before:opacity-0 before:transition-opacity before:duration-300',
					],
					{
						'group-focus-within:before:opacity-100 group-hover:before:opacity-100': !isMobile,
						'text-typography-inverse-strong before:opacity-100': isCenteredOnMobile,
					},
				)}
				label={
					<div className="relative flex shrink-0 flex-col text-center">
						<div className="flex items-center justify-center gap-1">
							<ChangeDot />
							<Text size="large" className="font-medium">
								{labelTitle}
							</Text>
						</div>

						<Text>{labelText}</Text>
					</div>
				}
			/>
		</div>
	);
};
